function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ResourceFilter = /*#__PURE__*/function () {
  function ResourceFilter() {
    _classCallCheck(this, ResourceFilter);

    this.filter = document.getElementById('resourceFilter');
    if (!this.filter || this.filter.length === 0) return;
    this.toggles = Array.from(this.filter.querySelectorAll('.filter__toggle'));
    this.bindEventHandlers();
  }

  _createClass(ResourceFilter, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      var _this = this;

      this.toggles.forEach(function (toggle) {
        return toggle.addEventListener('click', _this.handleToggle.bind(_this));
      });
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(evt) {
      this.toggles.filter(function (x) {
        return x.parentNode.id !== evt.target.parentNode.id;
      }).forEach(function (x) {
        return x.parentNode.open = false;
      });
    }
  }]);

  return ResourceFilter;
}();

export { ResourceFilter as default };